import React from "react";

import Accordian from "components/Accordian";

const Faq: React.FC<any> = ({ faqAccordionData }) => (
  <div className="container mx-auto">
    <div className="mb-16 text-center" id="faq">
      <span className="px-2 py-1 mb-6 font-medium rounded-full bg-primary-50 text-primary-500">
        Support
      </span>
      <h2 className="mt-1 mb-2 text-3xl font-bold text-gray-900">
        Frequently Asked Questions
      </h2>
      <p className="text-neutral-500">Have questions? We’re here to help</p>
    </div>
    <Accordian accordionData={faqAccordionData} />
  </div>
);

export default Faq;
